import React from "react";
import { ButtonA } from "../../styles-components/Buttons";
import {
  Column,
  ErrorMessage,
  Label,
  Row,
} from "../../styles-components/FormItens";
import inputFormat from "../../utils/inputFormat";
import { useState } from "react";
import { useRef } from "react";

const EventConfig = ({ setEventItems, eventItems = [] }) => {
  const [title, setTitle] = useState(" ");
  const [descricao, setDescricao] = useState(" ");
  const [validation, setValidation] = useState({ value: false, message: "" });

  const inputTitle = useRef(null);

  const handleNewItem = () => {
    if((title != '' && title != " " ) && (descricao != '' && descricao != " " )) {
      if (eventItems.find(item => " "+item.title === title) === undefined) {
        setEventItems((prev) => [
          ...prev,
          {
            title: removeValidationSpace(title),
            description: removeValidationSpace(descricao).replace("/\r?\n/g", '<br />')
          },
        ]);
        setTitle(" ");
        setDescricao(" ");
        setValidation({ value: false, message: "" });
      } else {
        inputTitle.current.focus();
        setValidation({ value: true, message: "Já existe um item com esse título" });
      }
    } else {
      setValidation({ value: true, message: "Informe todos os campos do item" });
    }
  };
  const removeValidationSpace = (text) => {
    return text[0] === " " ? text.substring(1) : text;
  };

  return (
    <Column style={{ marginTop: "10px" }}>
      <Column>
        <h4>Adicionar informação ao evento</h4>
        <Row>
          <Label>Titulo:</Label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            ref={inputTitle}
            style={title != " " && title.length < 1 ? { ...inputFormat } : {}}
          />
        </Row>
        {title != " " && title.length < 1 && (
          <ErrorMessage color="--red">Informe este campo!</ErrorMessage>
        )}
      </Column>
      <Column>
        <Column>
          <Label>Descrição:</Label>
          <textarea
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            style={
              descricao != " " && descricao.length < 1 ? { ...inputFormat } : {}
            }
          ></textarea>
        </Column>
        {descricao != " " && descricao.length < 1 && (
          <ErrorMessage color="--red">Informe este campo!</ErrorMessage>
        )}
      </Column>
      {validation.value && (
        <ErrorMessage align='center' color="--red">{validation.message}</ErrorMessage>
      )}
      <ButtonA
        as="button"
        type="button"
        backgroundColor="--green"
        color="--white"
        style={{ width: "fit-content" }}
        onClick={() => handleNewItem()}
      >
        Adicionar Item
      </ButtonA>
    </Column>
  );
};

export default EventConfig;
